import { http } from '../../services/http';
import { reactLocalStorage } from 'reactjs-localstorage';

export const sendDataToExternalBasket = (token, imagesOpenDoor, imagesCloseDoor) => {
  const myToken = token ?? reactLocalStorage.get('token');
  return dispatch => {
    return http
      .post(`/basket/submit`, {
        token: myToken,
        imagesOpenDoor,
        imagesCloseDoor,
        mode: 1,
      })
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(err => {
        return Promise.reject(err);
      });
  };
};

export const sendDataToExternalBasketOne = (item, value, mode, image = null) => {
  return dispatch => {
    const fakeToken =
      Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    return http
      .post(`/basket/submit`, { item, mode, token: fakeToken, qty: value, image })
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(err => {
        return Promise.reject(err);
      });
  };
};

export const submitAjaxToBrw = payload => {
  return dispatch => {
    return http
      .external(process.env.REACT_APP_AJAX_BASKET_URL, 'POST', { order: payload })
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(err => {
        return Promise.reject(err);
      });
  };
};

export const submitLogFromBrw = (token, payload) => {
  return dispatch => {
    return http
      .post(`/basket/save-log`, { token, payload })
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(err => {
        return Promise.reject(err);
      });
  };
};
